/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
export const createCustomInputControlValueAccessor = (extendedInputComponent: unknown): any => {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => extendedInputComponent),
    multi: true,
  };
};

@Component({
  template: "",
})
export class FormInputComponent<T> implements ControlValueAccessor {
  protected _value: T;
  public disabled = false;
  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onChangeCallback = (value: T): void => {};
  protected onTouchedCallback = (): void => {};

  public get value(): T {
    return this._value;
  }

  public set value(v: T) {
    if (this._value !== v) {
      this._value = v;
      this.onChangeCallback(v);
    }
  }

  // implements ControlValueAccessor interface
  public writeValue(value: T): void {
    this.value = value;
  }

  // implements ControlValueAccessor interface - not used, used for touch input
  public registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  // implements ControlValueAccessor interface
  public registerOnChange(fn: (value: T) => void): void {
    this.onChangeCallback = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    // disable other components here
  }
}
